import Http from "./http";

export const groupListDropdownAPI = (data) => {
  return Http.post("admin/notificationGroupList", data);
};